<template>
  <div :class="jel_getClassObject(content)">
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libTelephone"
      :rules="`required|is_telephone_valid|compteValidation:telephone`"
      tag="div"
    >
      <b-form-group :label="content.libTelephone" label-for="telephone">
        <!-- :value au lieu de v-model: éviter le keydown automatique de v-model -->
        <b-form-input
          :id="content.idHTML ? content.idHTML : 'telephone'"
          v-model="telephone"
          type="tel"
          :maxlength="$t('compte.telephone.mask').length"
          :state="getValidationState(validationContext)"
          @keydown.enter="getValidationState(validationContext)"
          @keyup.native="maskTelephone($event)"
        ></b-form-input>
        <ErreurValidation
          id="telephone-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
      <Hyperlien
        v-if="content.libExplication"
        class="mb-2 mt-n3"
        :content="getContentAide"
      ></Hyperlien>
    </ValidationProvider>
  </div>
</template>

<script>
import i18n from '@/js/i18n';

import Hyperlien from '@/components/base/Hyperlien';
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

export default {
  name: 'FormulaireTelephone',

  components: { ErreurValidation, Hyperlien },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      numeroPrecedent: [],
    };
  },
  computed: {
    telephone: {
      get() {
        return this.$store.state.compte.telephone;
      },
      set(value) {
        this.$store.commit('compte/SET_TELEPHONE', value);
      },
    },
    getContentAide() {
      return {
        texte: this.content.libExplication,
        type: 'aide',
        idQuestion: this.content.idQuestion,
      };
    },
  },
  methods: {
    // Passe-passe permettant de correcterment positionner le curseur sur delete/backspace
    // TODO: Un seul cas qui n'est pas traiter: backspace pour passer d'un bloc à l'autre (idem DateDeNaissance)
    maskTelephone(e) {
      // Inspiration: https://github.com/vuejs-tips/vue-the-mask/issues/56
      let caretPosition = e.target.selectionStart;
      // Match the masked characters using, in phone case it's - and a "space"

      const lastAmountOfSpaces = (e.target.value.match(/[\s-]/g) || []).length;

      let numeroSansIndentation = e.target.value.replace(/\W/g, '');
      if (this.numeroPrecedent[0] && this.numeroPrecedent[0] === numeroSansIndentation) {
        let sliceApres;
        let sliceAvant;
        if (e.key === 'Backspace' && caretPosition > 0) {
          switch (caretPosition) {
            case 3:
              sliceAvant = caretPosition - 1;
              sliceApres = -(numeroSansIndentation.length - caretPosition);
              break;
            case 7:
              sliceAvant = caretPosition - 2;
              sliceApres = -(numeroSansIndentation.length - caretPosition + 1);
              break;
            default:
          }

          if (numeroSansIndentation.length === 7) {
            caretPosition -= 1;
          } else {
            caretPosition -= 2;
          }
        } else if (e.key === 'Delete' && caretPosition < numeroSansIndentation.length) {
          switch (caretPosition) {
            case 3:
              sliceAvant = caretPosition;
              sliceApres = -(numeroSansIndentation.length - caretPosition - 1);
              break;
            case 7:
              sliceAvant = caretPosition - 1;
              sliceApres = -(numeroSansIndentation.length - caretPosition);
              break;
            default:
          }
          if (numeroSansIndentation.length === 7) {
            caretPosition += 1;
          }
        }
        if (sliceAvant && sliceApres) {
          numeroSansIndentation =
            numeroSansIndentation.slice(0, sliceAvant) + numeroSansIndentation.slice(sliceApres);
        }
      }
      // on veut permettre la saisie alphanumérique pour afficher un message si non numérique
      const replacedInput = numeroSansIndentation.match(/(\w{0,3})(\w{0,3})(\w{0,4})/);

      this.numeroPrecedent = replacedInput;
      const formattedValue = !replacedInput[2]
        ? replacedInput[1]
        : replacedInput[1] +
          (i18n.locale === 'en' ? '-' : ' ') +
          replacedInput[2] +
          (replacedInput[3] ? `-${replacedInput[3]}` : '');

      // this.numeroPrecedent.push(formattedValue);
      this.telephone = formattedValue;

      if (formattedValue === e.target.value) {
        return;
      }
      // Match the masked characters using, in phone case it's - and a "space"
      const newAmountOfSpaces = (formattedValue.match(/[\s-]/g) || []).length;

      caretPosition += newAmountOfSpaces - lastAmountOfSpaces;

      this.$nextTick(function () {
        e.target.setSelectionRange(caretPosition, caretPosition);
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      if (validated && !valid) {
        return valid;
      }
      return null;
    },
    formatterTelephone() {},
  },
};
</script>
